import { render, staticRenderFns } from "./ChatbaseWidget.vue?vue&type=template&id=94a70dd6"
import script from "./ChatbaseWidget.vue?vue&type=script&lang=ts"
export * from "./ChatbaseWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports